import React from "react";

const Page404 = () => (
  <svg
    width="28rem"
    height="17.8333rem"
    viewBox="0 0 672 428"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M282.192 159.069C282.192 159.069 288.202 159.88 315.801 159.318C323.27 163.787 355.635 160.946 368.395 159.759C383.144 162.452 390.438 155.418 383.883 151.62C381.867 150.446 378.528 149.584 373.685 149.405C374.003 134.29 336.03 129.33 325.449 151.384C319.854 146.916 308.171 147.331 307.399 153.375C296.598 151.422 288.066 153.624 284.156 155.929C282.081 157.142 281.31 158.386 282.192 159.069Z"
      fill="url(#paint0_linear_679:12566)"
    />
    <path
      d="M242.009 300.001C239.728 337.893 242.826 377.997 240.891 415.934L254.376 417.684L254.912 409.953L255.015 409.991C257.57 374.093 264.38 335.547 267.714 299.559L242.009 300.001Z"
      fill="url(#paint1_linear_679:12566)"
    />
    <path
      d="M254.997 398.003H241.411C241.322 403.846 241.166 409.689 240.891 415.454L246.774 416.279L253.626 415.629L254.027 409.377L254.123 409.416C254.374 405.638 254.68 401.827 255.009 397.997L254.997 398.003Z"
      fill="white"
    />
    <path
      d="M239.805 410.742L239.758 412.08C239.746 413.22 239.532 414.35 239.125 415.421L237.382 420.101C236.901 421.426 236.655 422.818 236.655 424.221V424.453C236.663 424.681 236.718 424.907 236.818 425.114C236.917 425.323 237.059 425.51 237.236 425.665C237.411 425.82 237.618 425.94 237.843 426.018C238.068 426.097 238.307 426.131 238.546 426.12H255.94C256.421 426.133 256.889 425.967 257.242 425.655C257.596 425.344 257.808 424.912 257.832 424.453V423.854C257.832 422.641 257.635 421.436 257.246 420.281L255.745 415.511C255.417 414.538 255.253 413.521 255.261 412.499V410.742C255.252 409.635 254.802 408.574 254.002 407.774L253.759 407.497C252.163 405.942 249.987 405.055 247.709 405.028C245.429 405.002 243.232 405.838 241.596 407.356L241.165 407.774C240.354 408.575 239.872 409.628 239.805 410.742Z"
      fill="url(#paint2_linear_679:12566)"
    />
    <path
      opacity="0.6"
      d="M236.655 423.309H257.783C257.822 423.527 257.838 423.748 257.83 423.968V424.537C257.823 424.754 257.767 424.968 257.668 425.165C257.568 425.363 257.426 425.541 257.25 425.688C257.073 425.835 256.867 425.949 256.642 426.023C256.417 426.097 256.178 426.13 255.939 426.119H238.546C238.066 426.133 237.598 425.974 237.245 425.679C236.891 425.383 236.68 424.973 236.655 424.537V423.315V423.309Z"
      fill="black"
    />
    <path
      d="M250.74 411.647C250.78 411.47 250.784 411.273 250.751 411.091C250.718 410.909 250.651 410.756 250.561 410.658C249.53 409.729 248.397 409.246 247.249 409.246C246.101 409.246 244.969 409.729 243.937 410.658C243.89 410.7 243.847 410.759 243.813 410.833C243.777 410.906 243.751 410.991 243.734 411.083C243.717 411.175 243.711 411.273 243.715 411.37C243.719 411.466 243.734 411.561 243.758 411.647C243.78 411.735 243.812 411.812 243.851 411.877C243.89 411.94 243.936 411.989 243.986 412.02C244.035 412.051 244.087 412.063 244.14 412.055C244.192 412.048 244.243 412.021 244.29 411.977C245.206 411.174 246.209 410.758 247.224 410.758C248.24 410.758 249.243 411.174 250.159 411.977C250.213 412.039 250.276 412.068 250.339 412.056C250.419 412.056 250.497 412.019 250.568 411.947C250.638 411.876 250.698 411.772 250.74 411.647Z"
      fill="white"
    />
    <path
      d="M250.74 413.259C250.78 413.171 250.784 413.073 250.75 412.983C250.717 412.893 250.65 412.818 250.561 412.77C249.531 412.302 248.397 412.059 247.248 412.059C246.099 412.059 244.965 412.302 243.934 412.77C243.84 412.812 243.768 412.888 243.735 412.98C243.701 413.072 243.708 413.172 243.755 413.259C243.802 413.345 243.884 413.411 243.984 413.443C244.083 413.473 244.193 413.467 244.287 413.424C245.203 413.02 246.207 412.81 247.223 412.81C248.239 412.81 249.243 413.02 250.159 413.424C250.212 413.455 250.276 413.469 250.339 413.464C250.419 413.463 250.498 413.444 250.568 413.409C250.638 413.373 250.698 413.322 250.74 413.259Z"
      fill="white"
    />
    <path
      d="M250.74 415.866C250.78 415.689 250.784 415.492 250.751 415.31C250.718 415.128 250.651 414.975 250.561 414.877C249.53 413.948 248.397 413.465 247.249 413.465C246.101 413.465 244.969 413.948 243.937 414.877C243.89 414.919 243.847 414.978 243.813 415.051C243.777 415.125 243.751 415.21 243.734 415.302C243.717 415.394 243.711 415.491 243.715 415.589C243.719 415.685 243.734 415.78 243.758 415.866C243.78 415.952 243.812 416.031 243.851 416.095C243.89 416.159 243.936 416.208 243.986 416.239C244.035 416.27 244.087 416.281 244.14 416.274C244.192 416.266 244.243 416.24 244.29 416.196C245.206 415.393 246.209 414.977 247.224 414.977C248.24 414.977 249.243 415.393 250.159 416.196C250.213 416.258 250.276 416.286 250.339 416.275C250.419 416.275 250.497 416.237 250.568 416.165C250.638 416.095 250.698 415.991 250.74 415.866Z"
      fill="white"
    />
    <path
      d="M319.95 416.277L308.71 408.172C307.812 407.505 307.072 406.663 306.538 405.701C306.005 404.739 305.691 403.679 305.616 402.592L307.388 326.536C307.388 326.123 307.388 325.717 307.348 325.304L305.365 299.559L277.597 302.542L282.721 332.122V332.756C282.11 345.281 283.065 357.83 285.563 370.137L285.987 372.244C287.448 379.601 289.153 389.434 290.297 398.492L291.772 415.598L319.95 416.277Z"
      fill="url(#paint3_linear_679:12566)"
    />
    <path
      d="M290.309 398.589L291.785 415.584L319.949 416.278L308.699 408.225C307.801 407.563 307.059 406.726 306.525 405.771C305.991 404.815 305.677 403.762 305.602 402.682L305.979 397.997L290.302 398.589"
      fill="white"
    />
    <path
      d="M291.973 409.973L298.029 411.947C298.462 412.087 298.923 412.11 299.367 412.014C299.812 411.919 300.226 411.708 300.57 411.401L305.354 407.178C305.876 406.714 306.537 406.451 307.225 406.435C307.913 406.418 308.585 406.648 309.128 407.086L319.929 415.762L328.443 418.669C329.665 419.098 330.728 419.91 331.483 420.994C332.238 422.077 332.648 423.378 332.655 424.714C332.653 425.087 332.51 425.444 332.255 425.708C332 425.971 331.655 426.12 331.295 426.121H293.555C293.128 426.123 292.705 426.038 292.31 425.869C291.915 425.701 291.556 425.454 291.254 425.141C290.952 424.829 290.712 424.458 290.549 424.049C290.385 423.641 290.302 423.203 290.302 422.76V411.25C290.307 411.042 290.356 410.838 290.448 410.654C290.541 410.469 290.673 410.309 290.834 410.185C290.995 410.062 291.182 409.979 291.38 409.942C291.577 409.905 291.781 409.916 291.973 409.973Z"
      fill="url(#paint4_linear_679:12566)"
    />
    <path
      opacity="0.6"
      d="M290.302 423.309H332.476C332.603 423.765 332.664 424.239 332.654 424.715C332.652 425.087 332.509 425.444 332.254 425.707C331.999 425.971 331.654 426.119 331.293 426.121H293.514C292.743 426.119 291.998 425.836 291.41 425.321C290.823 424.807 290.43 424.094 290.302 423.309Z"
      fill="black"
    />
    <path
      d="M309.206 411.938L311.388 408.625C311.446 408.536 311.478 408.419 311.478 408.299C311.478 408.178 311.446 408.062 311.388 407.974C311.326 407.887 311.243 407.839 311.157 407.839C311.071 407.839 310.988 407.887 310.927 407.974L308.746 411.288C308.688 411.376 308.655 411.492 308.655 411.613C308.655 411.733 308.688 411.849 308.746 411.938C308.804 412.014 308.879 412.056 308.958 412.058C309.046 412.047 309.132 412.006 309.206 411.938Z"
      fill="white"
    />
    <path
      d="M310.621 413.345L312.795 410.025C312.855 409.938 312.89 409.822 312.89 409.699C312.89 409.577 312.855 409.461 312.795 409.373C312.732 409.292 312.65 409.246 312.565 409.246C312.479 409.246 312.397 409.292 312.334 409.373L310.161 412.693C310.101 412.78 310.067 412.897 310.067 413.019C310.067 413.142 310.101 413.258 310.161 413.345C310.217 413.421 310.291 413.463 310.367 413.465C310.457 413.453 310.545 413.412 310.621 413.345Z"
      fill="white"
    />
    <path
      d="M313.445 414.75L315.618 411.432C315.679 411.344 315.713 411.228 315.713 411.106C315.713 410.983 315.679 410.867 315.618 410.78C315.555 410.698 315.474 410.652 315.388 410.652C315.303 410.652 315.221 410.698 315.158 410.78L312.985 414.099C312.924 414.185 312.89 414.302 312.89 414.424C312.89 414.546 312.924 414.663 312.985 414.75C313.041 414.823 313.114 414.866 313.19 414.87C313.283 414.878 313.374 414.835 313.445 414.75Z"
      fill="white"
    />
    <path
      d="M268.707 312.215L239.479 312.17L241.164 273.326C241.336 269.379 241.21 265.423 240.786 261.495C239.934 253.524 240.145 246.27 240.587 237.614L241.421 233.465L299.327 239.637L307.243 308.034L278.162 311.043L272.188 271.879L268.707 312.215Z"
      fill="url(#paint5_linear_679:12566)"
    />
    <g opacity="0.2">
      <path
        opacity="0.2"
        d="M272.48 272.769L271.838 272.757L272.159 244.063H275.324V261.479L273.411 265.238L272.833 264.944L274.682 261.325V244.703H272.801L272.48 272.769Z"
        fill="black"
      />
    </g>
    <g opacity="0.2">
      <path
        opacity="0.2"
        d="M298.854 254.78C292.763 249.217 291.069 241.353 291.049 241.309L291.691 241.181C291.691 241.257 293.366 248.853 299.304 254.307L298.854 254.78Z"
        fill="black"
      />
    </g>
    <path
      d="M231.648 192.696L232.283 186.592L237.569 206.232L239.475 244.666L256.473 245.826C271.17 246.918 285.933 244.971 299.858 240.107C298.664 214.196 294.14 179.545 294.14 179.545L292.558 168.869L312.891 158.61L304.631 139.246L295.506 141.349C291.275 141.888 281.165 143.837 281.165 143.837L264.352 144.587L243.218 143.625L220.661 151.762C213.258 155.494 213.259 166.17 213.259 166.17L211.244 190.536L231.648 192.696Z"
      fill="url(#paint6_linear_679:12566)"
    />
    <path
      d="M231.009 259.21L228.816 222.025L228.721 222.07L228.004 210.488L229.348 191.992L211.537 189.871L211.284 209.155C211.181 210.457 211.279 211.766 211.575 213.036L214.295 229.255L222.534 261.59L231.009 259.21Z"
      fill="url(#paint7_linear_679:12566)"
    />
    <path
      d="M334.833 137.474C327.28 125.619 292.887 108.309 292.887 108.309L286.067 114.036L313.098 137.474L304.874 139.413L313.098 158.934L329.273 150.686C338.274 146.096 334.833 137.474 334.833 137.474Z"
      fill="url(#paint8_linear_679:12566)"
    />
    <path
      d="M240.454 272.071L218.688 267.23C218.381 267.161 218.072 267.335 217.999 267.619L215.494 277.192C215.421 277.475 215.609 277.76 215.916 277.828L237.682 282.669C237.989 282.738 238.297 282.563 238.371 282.28L240.875 272.706C240.949 272.423 240.76 272.139 240.454 272.071Z"
      fill="#118052"
    />
    <path
      opacity="0.3"
      d="M240.454 272.071L218.688 267.23C218.381 267.161 218.072 267.335 217.999 267.619L215.494 277.192C215.421 277.475 215.609 277.76 215.916 277.828L237.682 282.669C237.989 282.738 238.297 282.563 238.371 282.28L240.875 272.706C240.949 272.423 240.76 272.139 240.454 272.071Z"
      fill="black"
    />
    <path
      d="M239.066 271.106L218.509 265.825C218.22 265.75 217.928 265.94 217.859 266.249L215.494 276.693C215.424 277.001 215.602 277.312 215.892 277.386L236.448 282.668C236.738 282.742 237.03 282.552 237.1 282.244L239.464 271.799C239.534 271.491 239.356 271.18 239.066 271.106Z"
      fill="#40E5A0"
    />
    <path
      opacity="0.4"
      d="M237.806 274.086C237.951 273.959 238.042 273.789 238.062 273.605C238.082 273.421 238.03 273.237 237.916 273.087C237.857 273.017 237.785 272.96 237.703 272.918C237.62 272.876 237.529 272.85 237.435 272.842C237.341 272.835 237.247 272.845 237.157 272.873C237.068 272.9 236.986 272.945 236.916 273.004C236.769 273.129 236.678 273.301 236.659 273.485C236.639 273.67 236.695 273.854 236.813 274.003C236.871 274.071 236.943 274.128 237.025 274.169C237.107 274.211 237.197 274.235 237.29 274.244C237.383 274.251 237.477 274.241 237.566 274.214C237.654 274.187 237.736 274.143 237.806 274.086Z"
      fill="black"
    />
    <path
      opacity="0.3"
      d="M237.799 274.085C237.948 273.961 238.042 273.789 238.062 273.604C238.082 273.419 238.027 273.233 237.908 273.084C237.851 273.016 237.779 272.959 237.697 272.917C237.614 272.876 237.524 272.85 237.431 272.843C237.338 272.834 237.244 272.845 237.156 272.872C237.067 272.899 236.985 272.943 236.915 273.001C236.77 273.127 236.679 273.298 236.659 273.483C236.639 273.666 236.691 273.851 236.806 274.003C236.863 274.071 236.936 274.128 237.017 274.169C237.099 274.211 237.19 274.236 237.283 274.244C237.376 274.251 237.47 274.241 237.558 274.214C237.647 274.187 237.729 274.143 237.799 274.085Z"
      fill="black"
    />
    <path
      opacity="0.4"
      d="M237.806 274.086C237.951 273.959 238.042 273.789 238.062 273.605C238.082 273.421 238.03 273.237 237.916 273.087C237.857 273.017 237.785 272.96 237.703 272.918C237.62 272.876 237.529 272.85 237.435 272.842C237.341 272.835 237.247 272.845 237.157 272.873C237.068 272.9 236.986 272.945 236.916 273.004C236.769 273.129 236.678 273.301 236.659 273.485C236.639 273.67 236.695 273.854 236.813 274.003C236.871 274.071 236.943 274.128 237.025 274.169C237.107 274.211 237.197 274.235 237.29 274.244C237.383 274.251 237.477 274.241 237.566 274.214C237.654 274.187 237.736 274.143 237.806 274.086Z"
      fill="black"
    />
    <path
      d="M237.799 274.085C237.948 273.961 238.042 273.789 238.062 273.604C238.082 273.419 238.027 273.233 237.908 273.084C237.851 273.016 237.779 272.959 237.697 272.917C237.614 272.876 237.524 272.85 237.431 272.843C237.338 272.834 237.244 272.845 237.156 272.872C237.067 272.899 236.985 272.943 236.915 273.001C236.77 273.127 236.679 273.298 236.659 273.483C236.639 273.666 236.691 273.851 236.806 274.003C236.863 274.071 236.936 274.128 237.017 274.169C237.099 274.211 237.19 274.236 237.283 274.244C237.376 274.251 237.47 274.241 237.558 274.214C237.647 274.187 237.729 274.143 237.799 274.085Z"
      fill="#3562FF"
    />
    <path
      opacity="0.3"
      d="M237.799 274.085C237.948 273.961 238.042 273.789 238.062 273.604C238.082 273.419 238.027 273.233 237.908 273.084C237.851 273.016 237.779 272.959 237.697 272.917C237.614 272.876 237.524 272.85 237.431 272.843C237.338 272.834 237.244 272.845 237.156 272.872C237.067 272.899 236.985 272.943 236.915 273.001C236.77 273.127 236.679 273.298 236.659 273.483C236.639 273.666 236.691 273.851 236.806 274.003C236.863 274.071 236.936 274.128 237.017 274.169C237.099 274.211 237.19 274.236 237.283 274.244C237.376 274.251 237.47 274.241 237.558 274.214C237.647 274.187 237.729 274.143 237.799 274.085Z"
      fill="black"
    />
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M230.589 171.544C230.525 171.549 230.461 171.53 230.41 171.491C230.36 171.452 230.325 171.396 230.313 171.333C229.758 168.476 228.633 165.759 227.005 163.343C225.376 160.927 223.277 158.861 220.833 157.268C220.802 157.25 220.776 157.228 220.754 157.2C220.732 157.173 220.716 157.141 220.707 157.108C220.699 157.075 220.696 157.039 220.7 157.005C220.704 156.97 220.716 156.937 220.733 156.906C220.75 156.876 220.773 156.85 220.801 156.828C220.828 156.807 220.86 156.791 220.894 156.782C220.927 156.773 220.962 156.771 220.997 156.775C221.032 156.779 221.065 156.791 221.096 156.807C223.603 158.437 225.756 160.551 227.429 163.024C229.101 165.497 230.259 168.279 230.833 171.206C230.84 171.239 230.84 171.274 230.834 171.308C230.828 171.342 230.815 171.374 230.796 171.403C230.776 171.431 230.751 171.456 230.722 171.475C230.693 171.494 230.661 171.507 230.627 171.512L230.589 171.544Z"
        fill="black"
      />
    </g>
    <path
      d="M285.221 103.81L282.956 102.758L277.137 99.9022L271.573 99.8711C271.43 99.8979 271.303 99.9775 271.217 100.093C271.132 100.209 271.095 100.352 271.114 100.493C271.165 101.116 271.446 102.043 272.658 101.837L268.606 101.452C268.457 101.44 268.307 101.473 268.178 101.548C268.049 101.623 267.947 101.735 267.885 101.869L267.732 102.211C267.483 102.758 268.83 103.555 269.429 103.655L269.748 103.711L266.169 103.25C266.082 103.261 265.997 103.291 265.922 103.336C265.847 103.381 265.782 103.44 265.731 103.511C265.681 103.582 265.646 103.663 265.629 103.747C265.613 103.832 265.614 103.918 265.633 104.003C265.683 104.408 265.829 104.796 266.061 105.136C266.29 105.26 263.508 105.036 262.443 104.955C262.391 104.949 262.338 104.956 262.288 104.973C262.239 104.991 262.195 105.02 262.159 105.057C262.123 105.095 262.096 105.14 262.081 105.189C262.066 105.238 262.063 105.29 262.073 105.341C262.181 105.963 262.794 107.208 265.684 107.65C269.717 108.272 271.356 107.886 271.356 107.886L274.413 109.261L273.953 111.097L269.602 110.3L269.372 112.721C269.965 113.126 274.853 114.507 274.853 114.507C274.853 114.507 281.578 115.752 283.556 115.198C285.534 114.644 286.982 114.177 286.982 114.177L293.126 108.676L285.221 103.81Z"
      fill="url(#paint9_linear_679:12566)"
    />
    <path
      opacity="0.15"
      d="M274.773 108.308C274.773 108.308 279.443 107.217 281.832 105.496"
      stroke="black"
      strokeWidth="0.462089"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M270.538 111.515L276.266 112.527C276.266 112.527 279.252 110.386 281.832 111.388"
      stroke="black"
      strokeWidth="0.462089"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M266.302 105.67C266.302 105.67 270.925 106.233 272.93 105.496C272.93 105.496 273.691 106.621 276.184 106.902"
      stroke="black"
      strokeWidth="0.462089"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M270.538 104.09C271.897 104.181 273.266 104.181 274.626 104.09C275.392 104.789 276.434 105.282 277.597 105.496"
      stroke="black"
      strokeWidth="0.462089"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M271.949 102.683C273.367 102.902 274.831 102.912 276.255 102.714L279.008 104.09"
      stroke="black"
      strokeWidth="0.462089"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M274.772 99.8711C274.754 102.691 274.513 105.503 274.05 108.261L273.804 109.715L271.949 108.625L271.982 99.941L274.772 99.8711Z"
      fill="black"
    />
    <path
      opacity="0.15"
      d="M274.773 111.848V115.34L270.538 114.111L271.154 111.121L274.773 111.848Z"
      fill="black"
    />
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M292.879 169.07C292.822 169.072 292.765 169.054 292.719 169.02C292.673 168.987 292.639 168.939 292.622 168.885C292.622 168.783 289.676 159.032 288.63 156.948C288.598 156.884 288.594 156.811 288.616 156.744C288.639 156.677 288.688 156.621 288.752 156.59C288.782 156.575 288.816 156.566 288.851 156.564C288.886 156.561 288.92 156.566 288.953 156.578C288.986 156.589 289.017 156.607 289.042 156.63C289.068 156.653 289.089 156.68 289.105 156.712C290.176 158.834 293.013 168.329 293.129 168.731C293.149 168.799 293.141 168.872 293.108 168.935C293.074 168.997 293.017 169.043 292.949 169.064L292.879 169.07Z"
        fill="black"
      />
    </g>
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M265.467 220.499C265.408 220.497 265.352 220.477 265.306 220.441C265.259 220.406 265.226 220.356 265.21 220.301C265.2 220.266 265.198 220.231 265.202 220.196C265.207 220.161 265.218 220.127 265.236 220.097C265.254 220.066 265.278 220.04 265.307 220.019C265.335 219.998 265.368 219.982 265.403 219.975C265.512 219.975 276.552 216.893 281.731 207.399C281.745 207.363 281.766 207.33 281.794 207.303C281.821 207.277 281.854 207.256 281.89 207.243C281.926 207.229 281.965 207.224 282.003 207.227C282.042 207.23 282.079 207.241 282.113 207.259C282.146 207.278 282.176 207.303 282.199 207.333C282.222 207.364 282.238 207.399 282.246 207.437C282.255 207.474 282.255 207.513 282.247 207.551C282.239 207.588 282.223 207.623 282.2 207.654C276.905 217.353 265.653 220.441 265.512 220.486L265.467 220.499Z"
        fill="black"
      />
    </g>
    <g opacity="0.15">
      <path
        opacity="0.15"
        d="M225.761 211.119C225.709 211.119 225.658 211.055 225.639 210.952C225.621 210.894 225.619 210.832 225.631 210.772C225.643 210.711 225.67 210.655 225.709 210.607C226.679 209.789 228.643 210.556 228.726 210.607C228.81 210.658 228.848 210.78 228.835 210.921C228.822 211.061 228.752 211.157 228.675 211.131C228.598 211.106 226.704 210.358 225.812 211.131C225.794 211.133 225.776 211.129 225.761 211.119Z"
        fill="black"
      />
    </g>
    <path
      d="M231.443 258.777L235.522 265.585L238.067 271.432L234.22 270.49C234.22 270.49 234.001 277.532 231.928 278.409C231.303 278.675 229.429 277.987 229.622 276.506C229.348 276.76 229.018 276.95 228.658 277.062C228.298 277.175 227.916 277.207 227.542 277.155C226.386 276.921 226.107 276.187 226.213 274.784C226.213 274.784 225.668 275.85 224.06 275.187C223.09 274.784 223.336 273.355 223.336 273.355C223.336 273.355 221.582 273.504 221.343 272.614C221.089 271.161 221.057 269.679 221.25 268.216L222.3 263.292L222.692 260.109L231.443 258.777Z"
      fill="url(#paint10_linear_679:12566)"
    />
    <path
      opacity="0.15"
      d="M223.95 272.839C223.95 271.922 223.95 270.98 223.95 270.027"
      stroke="black"
      strokeWidth="0.46979"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M226.773 274.246C226.773 273.332 226.773 272.389 226.773 271.434"
      stroke="black"
      strokeWidth="0.46979"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.15"
      d="M229.596 275.653C230.276 274.271 230.749 272.86 231.007 271.434"
      stroke="black"
      strokeWidth="0.46979"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M240.891 110.691L244.104 127.808L243.525 143.711L252.633 147.069C255.638 148.172 258.79 148.85 261.991 149.083H262.472C262.919 149.112 263.368 149.043 263.785 148.881C264.202 148.719 264.578 148.469 264.884 148.147C265.191 147.826 265.421 147.443 265.559 147.024C265.696 146.605 265.737 146.162 265.679 145.726L264.401 135.343L269.67 135.182C269.849 135.192 270.03 135.192 270.21 135.182C273.601 134.995 275.511 134.42 275.531 129.003L275.155 122.501L277.052 121.274C277.091 121.254 277.126 121.227 277.157 121.196C277.398 120.998 277.553 120.717 277.589 120.411C277.624 120.104 277.538 119.795 277.348 119.55L273.456 114.933L273.357 114.591L273.45 113.81C273.811 110.525 273.255 107.207 271.843 104.208L270.447 101.277L240.891 110.691Z"
      fill="url(#paint11_linear_679:12566)"
    />
    <path
      d="M270.354 106.412L262.875 107.881C259.328 110.425 264.857 114.273 256.282 116.111C256.124 117.096 257.397 120.963 255.75 121.198C254.483 121.51 254.357 119.78 254.173 118.922L249.436 120.499C250.171 126.471 248.043 128.08 244.819 129.402C240.056 121.415 229.714 103.855 243.711 100.822C245.072 100.898 245.547 99.3589 245.927 98.8438C247.194 95.454 253.128 93.2281 257.175 94.7163C258.566 95.6066 260.153 96.1409 261.796 96.2732C263.44 96.4048 265.092 96.1301 266.605 95.4731C274.281 92.5349 278.499 103.995 270.354 106.412Z"
      fill="url(#paint12_linear_679:12566)"
    />
    <path
      opacity="0.15"
      d="M264.89 139.246L259.539 136.248C259.433 136.174 259.351 136.078 259.301 135.971C259.25 135.864 259.232 135.748 259.249 135.634C259.272 135.455 259.38 135.291 259.548 135.177C259.716 135.065 259.931 135.012 260.145 135.031L264.128 135.347L264.89 139.246Z"
      fill="black"
    />
    <path
      d="M263.774 135.028L260 134.524C253.448 134.324 253.597 119.026 253.597 119.026L255.869 118.152C256.264 124.664 258.679 127.485 258.679 127.485C261.593 131.193 264.506 130.38 266.377 129.111C267.497 128.347 268.352 126.721 268.908 125.519C270.579 121.878 274.444 123.426 274.444 123.426L274.774 128.948C274.774 134.039 272.877 134.579 269.543 134.755C269.365 134.764 269.189 134.764 269.012 134.755"
      fill="url(#paint13_linear_679:12566)"
    />
    <path
      opacity="0.15"
      d="M246.538 127.996L250.773 126.038C250.037 125.4 249.37 124.639 248.789 123.777C248.653 124.639 248.384 125.456 247.997 126.181C247.61 126.906 247.114 127.523 246.538 127.996Z"
      fill="black"
    />
    <path
      d="M270.82 116.737C271.584 116.674 272.076 116.313 271.92 115.929C271.764 115.546 271.018 115.287 270.254 115.349C269.49 115.412 268.998 115.774 269.155 116.157C269.311 116.541 270.056 116.8 270.82 116.737Z"
      fill="black"
    />
    <path
      d="M274.772 127.549C273.911 127.497 273.05 127.643 272.219 127.981C272.174 128.003 272.125 128 272.081 127.974C272.037 127.948 272 127.9 271.977 127.84C271.953 127.778 271.944 127.706 271.952 127.636C271.959 127.565 271.982 127.501 272.017 127.454C272.757 126.33 273.694 125.542 274.719 125.183L274.772 127.549Z"
      fill="white"
    />
    <path
      d="M271.947 111.401C271.874 111.602 270.624 111.677 269.15 111.968C267.676 112.258 266.571 112.638 266.333 112.497C266.228 112.427 266.386 112.221 266.823 111.977C267.414 111.658 268.087 111.424 268.806 111.289C269.543 111.141 270.312 111.091 271.074 111.139C271.669 111.19 271.98 111.303 271.947 111.401Z"
      fill="black"
    />
    <path
      opacity="0.15"
      d="M312.89 137.84C312.89 137.84 316.903 140.807 319.949 142.059"
      stroke="black"
      strokeWidth="0.770148"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.2"
      d="M250.772 329.09C250.772 329.09 255.815 329.017 257.832 327.683"
      stroke="black"
      strokeWidth="0.770148"
      strokeMiterlimit="10"
    />
    <path
      opacity="0.2"
      d="M301.596 329.09C301.596 329.09 305.097 329.09 305.832 329.09"
      stroke="black"
      strokeWidth="0.770148"
      strokeMiterlimit="10"
    />
    <g opacity="0.2">
      <path
        opacity="0.2"
        d="M242.456 258.641L242.264 258.001C249.786 255.681 251.66 245.988 251.673 245.892L252.315 246.007C252.29 246.135 250.351 256.198 242.456 258.641Z"
        fill="black"
      />
    </g>
    <path
      d="M278.257 123.16C278.081 121.879 277.69 120.637 277.102 119.484C271.46 120.929 260.414 120.386 260.414 120.386L260.363 120.558L251.942 117.406L250.658 124.509L258.521 127.488L258.469 127.693C266.21 134.138 272.481 135.307 272.481 135.307C276.691 133.39 278.572 127.137 278.257 123.16ZM251.358 124.1L252.449 118.289L260.215 121.178L258.662 126.868L251.358 124.1Z"
      fill="url(#paint14_linear_679:12566)"
    />
    <path
      d="M254.456 119.07C254.372 118.695 254.203 118.339 253.961 118.021C253.718 117.705 253.406 117.433 253.043 117.222C252.68 117.012 252.273 116.867 251.845 116.796C251.418 116.725 250.978 116.729 250.553 116.808C249.7 116.981 248.956 117.439 248.483 118.086C248.009 118.732 247.842 119.516 248.017 120.27L248.352 121.683C249.114 124.85 251.453 127.146 255.008 126.471L254.456 119.07Z"
      fill="url(#paint15_linear_679:12566)"
    />
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M253.13 120.705L252.854 119.388C252.738 118.837 252.408 118.355 251.937 118.045C251.466 117.735 250.892 117.623 250.338 117.732C250.032 117.791 249.742 117.918 249.491 118.103C249.24 118.288 249.034 118.526 248.887 118.8V118.857C248.86 118.915 248.844 118.978 248.842 119.042C248.839 119.105 248.849 119.169 248.872 119.229C248.895 119.289 248.93 119.343 248.974 119.389C249.019 119.435 249.072 119.472 249.131 119.497C249.189 119.526 249.252 119.543 249.317 119.547C249.381 119.55 249.446 119.541 249.506 119.518C249.567 119.495 249.622 119.459 249.668 119.414C249.714 119.369 249.749 119.314 249.773 119.254C249.844 119.09 249.954 118.945 250.094 118.834C250.234 118.723 250.399 118.648 250.575 118.614C250.732 118.582 250.893 118.58 251.05 118.61C251.207 118.639 251.356 118.699 251.49 118.787C251.624 118.874 251.739 118.987 251.828 119.119C251.918 119.25 251.981 119.399 252.013 119.554L252.289 120.878C252.322 121 252.399 121.106 252.506 121.176C252.613 121.245 252.741 121.273 252.867 121.255C252.924 121.242 252.977 121.216 253.023 121.179C253.069 121.142 253.106 121.096 253.131 121.043C253.156 120.99 253.169 120.933 253.169 120.874C253.169 120.816 253.156 120.758 253.13 120.705Z"
        fill="black"
      />
    </g>
    <path
      d="M415.949 102.683H404.655V426.121H415.949V102.683Z"
      fill="#42464C"
    />
    <path
      d="M489.361 37.9958H336.891V108.308H489.361V37.9958Z"
      fill="url(#paint16_linear_679:12566)"
    />
    <path
      d="M403.244 426.095C403.214 424.902 403.051 423.717 402.76 422.569C402.154 420.238 401.199 418.039 399.935 416.063C397.298 411.843 393.627 407.865 389.248 406.051C388.233 405.612 387.175 405.311 386.096 405.155C385.588 405.094 384.016 404.824 383.622 405.323C383.229 405.822 383.725 405.714 384.112 405.896C384.885 406.281 385.629 406.732 386.338 407.245C392.992 411.802 400.855 417.128 402.615 426.122L403.244 426.095Z"
      fill="#00BC7D"
    />
    <path
      opacity="0.2"
      d="M403.244 426.095C403.214 424.902 403.051 423.717 402.76 422.569C402.154 420.238 401.199 418.039 399.935 416.063C397.298 411.843 393.627 407.865 389.248 406.051C388.233 405.612 387.175 405.311 386.096 405.155C385.588 405.094 384.016 404.824 383.622 405.323C383.229 405.822 383.725 405.714 384.112 405.896C384.885 406.281 385.629 406.732 386.338 407.245C392.992 411.802 400.855 417.128 402.615 426.122L403.244 426.095Z"
      fill="black"
    />
    <path
      d="M405.699 425.959C405.285 419.406 403.285 413.095 401.094 406.926C400.101 404.12 399.121 401.275 397.884 398.553C396.391 395.26 394.562 392.063 392.772 388.943C391.924 387.457 391.049 385.99 390.101 384.561C389.674 383.92 389.233 383.28 388.786 382.639C388.601 382.402 387.72 381.601 387.713 381.319C387.713 380.903 388.115 381.249 388.371 381.39C388.971 381.759 389.54 382.173 390.075 382.626C391.367 383.729 392.547 384.951 393.601 386.272C395.884 389.058 397.755 392.141 399.16 395.433C400.45 398.701 401.563 402.032 402.496 405.414C403.711 409.312 404.669 413.281 405.364 417.298C405.665 419.097 405.872 420.91 405.982 422.731C406.022 423.499 406.035 424.268 406.028 425.037C406.028 425.223 406.114 425.761 406.028 425.902C405.956 425.895 405.726 426.357 405.699 425.959Z"
      fill="#00BC7D"
    />
    <path
      opacity="0.2"
      d="M405.699 425.959C405.285 419.406 403.285 413.095 401.094 406.926C400.101 404.12 399.121 401.275 397.884 398.553C396.391 395.26 394.562 392.063 392.772 388.943C391.924 387.457 391.049 385.99 390.101 384.561C389.674 383.92 389.233 383.28 388.786 382.639C388.601 382.402 387.72 381.601 387.713 381.319C387.713 380.903 388.115 381.249 388.371 381.39C388.971 381.759 389.54 382.173 390.075 382.626C391.367 383.729 392.547 384.951 393.601 386.272C395.884 389.058 397.755 392.141 399.16 395.433C400.45 398.701 401.563 402.032 402.496 405.414C403.711 409.312 404.669 413.281 405.364 417.298C405.665 419.097 405.872 420.91 405.982 422.731C406.022 423.499 406.035 424.268 406.028 425.037C406.028 425.223 406.114 425.761 406.028 425.902C405.956 425.895 405.726 426.357 405.699 425.959Z"
      fill="black"
    />
    <path
      d="M408.62 426.121H408.891C408.891 425.713 408.891 425.299 408.891 424.892C408.891 423.739 408.891 422.587 408.837 421.434C408.769 418.842 408.634 416.244 408.377 413.665C407.917 408.908 407.375 404.164 405.623 399.655C405.23 398.617 404.778 397.599 404.27 396.605C404.176 396.433 403.479 394.923 403.262 395.223C403.188 395.331 403.357 395.898 403.377 396.025C403.452 396.458 403.533 396.891 403.607 397.299C403.797 398.35 403.993 399.394 404.203 400.438C405.13 405.119 406.347 409.742 407.118 414.448C407.741 418.339 408.208 422.224 408.62 426.121Z"
      fill="#00BC7D"
    />
    <path
      opacity="0.2"
      d="M408.62 426.121H408.891C408.891 425.713 408.891 425.299 408.891 424.892C408.891 423.739 408.891 422.587 408.837 421.434C408.769 418.842 408.634 416.244 408.377 413.665C407.917 408.908 407.375 404.164 405.623 399.655C405.23 398.617 404.778 397.599 404.27 396.605C404.176 396.433 403.479 394.923 403.262 395.223C403.188 395.331 403.357 395.898 403.377 396.025C403.452 396.458 403.533 396.891 403.607 397.299C403.797 398.35 403.993 399.394 404.203 400.438C405.13 405.119 406.347 409.742 407.118 414.448C407.741 418.339 408.208 422.224 408.62 426.121Z"
      fill="white"
    />
    <path
      d="M411.94 411.922C411.547 409.219 411.667 406.482 412.293 403.81C412.572 402.228 413.034 400.672 413.674 399.164C414.375 397.753 415.268 396.414 416.335 395.171C416.749 394.664 417.164 394.156 417.562 393.642C417.677 393.489 418.329 392.372 418.49 392.372C419.188 392.309 418.391 394.911 418.253 395.311C417.687 396.738 416.933 398.108 416.005 399.399C415.077 400.78 414.363 402.254 413.881 403.785C413.326 405.373 412.875 406.986 412.531 408.615C412.385 409.345 412.27 410.075 412.209 410.811C412.251 411.1 412.251 411.392 412.209 411.681C412.224 411.56 411.987 412.373 411.94 411.922Z"
      fill="#00BC7D"
    />
    <path
      opacity="0.2"
      d="M411.94 411.922C411.547 409.219 411.667 406.482 412.293 403.81C412.572 402.228 413.034 400.672 413.674 399.164C414.375 397.753 415.268 396.414 416.335 395.171C416.749 394.664 417.164 394.156 417.562 393.642C417.677 393.489 418.329 392.372 418.49 392.372C419.188 392.309 418.391 394.911 418.253 395.311C417.687 396.738 416.933 398.108 416.005 399.399C415.077 400.78 414.363 402.254 413.881 403.785C413.326 405.373 412.875 406.986 412.531 408.615C412.385 409.345 412.27 410.075 412.209 410.811C412.251 411.1 412.251 411.392 412.209 411.681C412.224 411.56 411.987 412.373 411.94 411.922Z"
      fill="black"
    />
    <path
      d="M441.301 402.534C440.89 402.01 438.428 402.278 437.853 402.328C436.814 402.433 435.789 402.642 434.797 402.952C429.265 404.632 425.111 408.823 421.598 413.063C418.803 416.435 415.779 421.563 414.538 426.122H415.381C415.518 425.543 415.688 424.972 415.89 424.411C416.501 423.08 417.233 421.803 418.078 420.595C419.791 418.123 421.76 415.822 423.955 413.725C427.824 410.035 432.254 406.925 437.095 404.502C438.117 403.981 439.178 403.534 440.269 403.165C440.557 403.065 441.628 402.959 441.301 402.534Z"
      fill="#00BC7D"
    />
    <path
      d="M80.3821 69.7397C80.3821 69.7397 87.8479 70.7728 122.179 70.0516C131.461 75.7564 171.705 72.1308 187.567 70.6169C205.907 74.0606 214.972 65.068 206.825 60.2209C204.315 58.72 200.162 57.6219 194.141 57.388C194.532 38.0644 147.317 31.7294 134.164 59.922C127.199 54.2172 112.678 54.724 111.696 62.456C98.2602 59.9675 87.6489 62.7809 82.8087 65.7048C80.273 67.2707 79.3101 68.8626 80.3821 69.7397Z"
      fill="url(#paint17_linear_679:12566)"
    />
    <path
      d="M603.371 83.1318C603.371 83.1318 597.441 83.9424 570.206 83.3807C562.843 87.8489 530.913 85.0084 518.325 83.8211C503.774 86.5149 496.578 79.4805 503.038 75.6825C505.034 74.508 508.328 73.6463 513.106 73.4675C512.792 58.3521 550.256 53.3923 560.694 75.4463C566.214 70.9781 577.74 71.393 578.502 77.4379C589.158 75.4846 597.575 77.6869 601.426 79.9912C603.46 81.204 604.221 82.4487 603.371 83.1318Z"
      fill="url(#paint18_linear_679:12566)"
    />
    <path
      d="M670.343 427.518H2.0241C1.88482 427.535 1.74169 427.529 1.60562 427.502C1.46891 427.475 1.34248 427.426 1.23466 427.36C1.12683 427.294 1.04081 427.212 0.981118 427.12C0.921428 427.027 0.890625 426.926 0.890625 426.824C0.890625 426.723 0.921428 426.622 0.981118 426.529C1.04081 426.437 1.12683 426.355 1.23466 426.289C1.34248 426.223 1.46891 426.174 1.60562 426.147C1.74169 426.12 1.88482 426.114 2.0241 426.131H670.343C670.484 426.114 670.625 426.12 670.76 426.147C670.901 426.174 671.023 426.223 671.132 426.289C671.241 426.355 671.325 426.437 671.389 426.529C671.447 426.622 671.479 426.723 671.479 426.824C671.479 426.926 671.447 427.027 671.389 427.12C671.325 427.212 671.241 427.294 671.132 427.36C671.023 427.426 670.901 427.475 670.76 427.502C670.625 427.529 670.484 427.535 670.343 427.518Z"
      fill="#00BC7D"
    />
    <g opacity="0.6">
      <path
        opacity="0.6"
        d="M670.343 427.813H2.0241C1.88482 427.836 1.74169 427.828 1.60562 427.79C1.46891 427.753 1.34248 427.686 1.23466 427.594C1.12683 427.503 1.04081 427.39 0.981118 427.262C0.921428 427.134 0.890625 426.994 0.890625 426.854C0.890625 426.713 0.921428 426.574 0.981118 426.446C1.04081 426.318 1.12683 426.204 1.23466 426.113C1.34248 426.022 1.46891 425.955 1.60562 425.917C1.74169 425.879 1.88482 425.872 2.0241 425.895H670.343C670.484 425.872 670.625 425.879 670.76 425.917C670.901 425.955 671.023 426.022 671.132 426.113C671.241 426.204 671.325 426.318 671.389 426.446C671.447 426.574 671.479 426.713 671.479 426.854C671.479 426.994 671.447 427.134 671.389 427.262C671.325 427.39 671.241 427.503 671.132 427.594C671.023 427.686 670.901 427.753 670.76 427.79C670.625 427.828 670.484 427.836 670.343 427.813Z"
        fill="#118052"
      />
    </g>
    <path
      d="M451.281 32.8557L453.446 37.7014C453.475 37.7491 453.515 37.7885 453.564 37.8156C453.613 37.8427 453.667 37.8568 453.723 37.8562H456.654C457.685 37.8562 458.96 37.6433 459.07 39.095C459.07 39.5015 459.714 39.508 459.714 39.095C459.514 36.5141 456.3 37.2239 454.522 37.2239H453.877C453.536 37.2239 454.051 37.5207 453.935 37.2561C453.691 36.7142 453.446 36.1722 453.207 35.6302C452.743 34.5978 452.282 33.5654 451.822 32.5331C451.655 32.1653 451.107 32.4879 451.275 32.8557H451.281Z"
      fill="black"
    />
    <path
      d="M453.705 36.6521C451.757 36.6521 448.578 35.9849 448.42 39.0116C448.42 39.5323 449.175 39.5323 449.175 39.0116C449.228 37.8644 449.93 37.4494 450.866 37.4494H453.69C453.79 37.4494 453.886 37.4063 453.957 37.3298C454.028 37.2533 454.067 37.15 454.067 37.0426C454.067 36.9344 454.028 36.8311 453.957 36.7546C453.886 36.6781 453.79 36.6358 453.69 36.6358L453.705 36.6521Z"
      fill="black"
    />
    <path
      d="M434.301 24.4127C434.301 24.4127 445.687 13.9892 449.482 9.79938C453.277 5.60952 458.147 3.27112 462.921 4.63571C467.695 6.0003 470.799 11.2601 469.148 17.8844C467.497 24.5088 459.836 34.2467 449.488 33.7598C439.14 33.2729 435.754 26.3602 434.301 24.4127Z"
      fill="url(#paint19_linear_679:12566)"
    />
    <path
      d="M463.145 4.62964C458.517 3.28629 453.789 5.5883 450.099 9.71295C448.788 11.1824 446.533 13.434 444.185 15.7233L446.719 18.3091L451.416 14.7205C451.416 14.7205 451.416 10.8923 454.522 10.577C459.076 10.1229 458.393 19.6083 469.588 14.6449C469.78 9.5868 467.028 5.75226 463.145 4.62964Z"
      fill="url(#paint20_linear_679:12566)"
    />
    <path
      d="M465.36 12.6838C465.36 12.9622 465.279 13.2342 465.123 13.4654C464.967 13.6971 464.747 13.8769 464.487 13.9835C464.227 14.0896 463.943 14.1173 463.671 14.0625C463.4 14.0077 463.145 13.8734 462.948 13.6757C462.752 13.4786 462.619 13.2273 462.567 12.9541C462.509 12.6815 462.538 12.3985 462.648 12.1414C462.752 11.8843 462.937 11.6653 463.168 11.5114C463.4 11.3575 463.677 11.2762 463.955 11.2774C464.14 11.2774 464.325 11.3137 464.493 11.3846C464.666 11.4549 464.822 11.5586 464.95 11.6895C465.083 11.8203 465.187 11.9754 465.256 12.146C465.326 12.3166 465.36 12.4993 465.36 12.6838Z"
      fill="black"
    />
    <path
      d="M469.98 11.2773C469.98 11.2773 472.367 13.0669 472.419 13.8012C472.47 14.5355 470.112 16.9026 470.112 16.9026C470.112 16.9026 469.046 13.4732 469.98 11.2773Z"
      fill="black"
    />
    <path
      d="M449.832 32.8597L452.007 37.6977C452.034 37.7474 452.074 37.7887 452.123 37.8171C452.172 37.8455 452.228 37.8603 452.285 37.859H455.235C456.271 37.859 457.546 37.6397 457.656 39.0975C457.688 39.5039 458.303 39.5039 458.303 39.0975C458.109 36.5173 454.873 37.2204 453.126 37.2204H452.479C452.136 37.2204 452.654 37.5171 452.537 37.2591L451.806 35.6335L450.414 32.5372C450.246 32.1631 449.696 32.4856 449.864 32.8597H449.832Z"
      fill="black"
    />
    <path
      d="M452.293 36.6517C450.345 36.6517 447.166 35.9857 447.008 39.0153C447.008 39.5352 447.763 39.527 447.763 39.0153C447.816 37.8701 448.518 37.4558 449.454 37.4558H452.278C452.377 37.4558 452.474 37.4128 452.544 37.3372C452.615 37.2609 452.655 37.1578 452.655 37.0497C452.655 36.9417 452.615 36.8385 452.544 36.763C452.474 36.6866 452.377 36.6436 452.278 36.6436L452.293 36.6517Z"
      fill="black"
    />
    <path
      d="M428.655 27.6916C428.655 27.6916 441.758 15.649 445.091 13.7184C448.424 11.7878 453.853 12.3076 455.228 17.4311C456.739 23.0744 451.559 33.1323 436.939 27.6916L432.529 35.1844L428.655 27.6916Z"
      fill="url(#paint21_linear_679:12566)"
    />
    <path
      d="M269.988 159.875L264.205 161.296C260.468 162.214 259.391 164.701 260.217 168.039L261.589 173.577C262.411 176.896 264.526 178.598 268.263 177.68L274.046 176.259C277.78 175.341 278.86 172.854 278.038 169.535L276.666 163.997C275.84 160.659 273.722 158.957 269.988 159.875ZM267.66 172.498L272.078 171.413L271.828 170.406L274.837 169.666L275.579 172.664L272.571 173.403L272.321 172.396L267.903 173.481C267.877 173.764 267.774 174.034 267.605 174.261C267.435 174.489 267.206 174.666 266.942 174.772C266.678 174.879 266.39 174.911 266.11 174.865C265.829 174.819 265.566 174.697 265.35 174.512C265.134 174.327 264.974 174.087 264.886 173.817C264.799 173.547 264.787 173.259 264.853 172.983C264.92 172.707 265.061 172.455 265.261 172.254C265.462 172.053 265.714 171.911 265.991 171.843C266.217 171.787 266.454 171.783 266.682 171.832L270.7 165.204C270.661 165.158 270.625 165.11 270.593 165.059L266.174 166.145L266.423 167.152L263.416 167.891L262.674 164.894L265.681 164.155L265.93 165.162L270.35 164.076C270.375 163.793 270.478 163.523 270.648 163.296C270.818 163.068 271.047 162.891 271.31 162.785C271.574 162.678 271.862 162.646 272.143 162.692C272.424 162.738 272.687 162.86 272.902 163.045C273.118 163.23 273.279 163.47 273.366 163.74C273.454 164.01 273.465 164.298 273.399 164.574C273.333 164.85 273.192 165.102 272.991 165.303C272.791 165.504 272.538 165.646 272.262 165.714C272.035 165.771 271.798 165.775 271.569 165.725L267.552 172.353C267.59 172.4 267.626 172.448 267.66 172.498ZM274.093 170.892L273.059 171.146L273.314 172.177L274.349 171.923L274.093 170.892ZM272.019 164.734C272.139 164.704 272.244 164.633 272.318 164.534C272.391 164.436 272.428 164.315 272.421 164.192C272.415 164.069 272.366 163.952 272.283 163.862C272.2 163.771 272.088 163.711 271.966 163.694C271.844 163.676 271.72 163.701 271.614 163.764C271.508 163.828 271.428 163.926 271.387 164.041C271.346 164.157 271.346 164.284 271.388 164.399C271.43 164.515 271.511 164.612 271.617 164.675C271.738 164.747 271.883 164.768 272.019 164.734ZM264.159 166.665L265.193 166.411L264.937 165.38L263.904 165.634L264.159 166.665ZM266.233 172.824C266.131 172.848 266.038 172.903 265.967 172.98C265.896 173.058 265.849 173.155 265.833 173.258C265.817 173.362 265.832 173.469 265.877 173.564C265.921 173.659 265.993 173.739 266.084 173.793C266.174 173.848 266.278 173.874 266.383 173.87C266.489 173.865 266.59 173.829 266.675 173.767C266.76 173.705 266.825 173.619 266.861 173.52C266.897 173.421 266.902 173.314 266.877 173.212C266.843 173.076 266.757 172.958 266.636 172.885C266.515 172.812 266.37 172.79 266.233 172.824Z"
      fill="white"
    />
    <path
      d="M360.22 83.5485V75.8258L372.729 55.9547L378.465 59.7031L367.762 76.7291L368.394 77.6774H377.517V66.1161H384.336V77.6774H388.13V83.5485H384.336V89.8711H377.517V83.5485H360.22ZM411.743 90.7292C409.124 90.7292 406.881 90.3077 405.014 89.4646C403.148 88.6216 401.627 87.4474 400.453 85.942C399.279 84.4366 398.421 82.7205 397.879 80.7936C397.337 78.8667 397.066 76.8194 397.066 74.6516V72.0774C397.066 69.0967 397.593 66.387 398.647 63.9483C399.7 61.4795 401.311 59.5225 403.479 58.0773C405.647 56.6321 408.401 55.9095 411.743 55.9095C415.085 55.9095 417.825 56.6321 419.963 58.0773C422.131 59.5225 423.741 61.4795 424.795 63.9483C425.849 66.387 426.376 69.0967 426.376 72.0774V74.6516C426.376 76.8194 426.09 78.8667 425.518 80.7936C424.976 82.7205 424.118 84.4366 422.944 85.942C421.799 87.4474 420.294 88.6216 418.427 89.4646C416.591 90.3077 414.363 90.7292 411.743 90.7292ZM411.743 83.9098C414.182 83.9098 415.989 83.0667 417.163 81.3807C418.367 79.6646 418.969 77.0151 418.969 73.4323C418.969 69.6387 418.352 66.9139 417.118 65.258C415.913 63.572 414.122 62.7289 411.743 62.7289C409.335 62.7289 407.513 63.5569 406.279 65.2128C405.075 66.8688 404.472 69.5785 404.472 73.3419C404.472 76.985 405.06 79.6646 406.234 81.3807C407.438 83.0667 409.275 83.9098 411.743 83.9098ZM435.846 83.5485V75.8258L448.356 55.9547L454.091 59.7031L443.388 76.7291L444.02 77.6774H453.143V66.1161H459.962V77.6774H463.756V83.5485H459.962V89.8711H453.143V83.5485H435.846Z"
      fill="#42464C"
    />
    <defs>
      <linearGradient
        id="paint0_linear_679:12566"
        x1="333.685"
        y1="149.32"
        x2="334.056"
        y2="161.746"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#CFF8E7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_679:12566"
        x1="261.77"
        y1="352.721"
        x2="240.65"
        y2="355.271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_679:12566"
        x1="254.818"
        y1="412.914"
        x2="237"
        y2="416.312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42464C" />
        <stop offset="1" stopColor="#212326" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_679:12566"
        x1="310.564"
        y1="352.089"
        x2="277.944"
        y2="358.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_679:12566"
        x1="326.628"
        y1="413.794"
        x2="294.981"
        y2="426.726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42464C" />
        <stop offset="1" stopColor="#212326" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_679:12566"
        x1="297.599"
        y1="262.907"
        x2="240.047"
        y2="272.314"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42464C" />
        <stop offset="1" stopColor="#212326" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_679:12566"
        x1="269.025"
        y1="152.464"
        x2="210.466"
        y2="192.505"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#44E9A4" />
        <stop offset="1" stopColor="#0A5133" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_679:12566"
        x1="226.629"
        y1="222.148"
        x2="211.172"
        y2="224.413"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_679:12566"
        x1="285.637"
        y1="108.279"
        x2="328.415"
        y2="130.078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_679:12566"
        x1="286.244"
        y1="106.833"
        x2="274.645"
        y2="119.212"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_679:12566"
        x1="234.313"
        y1="267.638"
        x2="223.121"
        y2="272.757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_679:12566"
        x1="269.462"
        y1="122.795"
        x2="244.326"
        y2="133.053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_679:12566"
        x1="281.354"
        y1="79.2978"
        x2="241.154"
        y2="117.589"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0B5335" />
        <stop offset="1" stopColor="#00170E" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_679:12566"
        x1="264.185"
        y1="118.152"
        x2="257.393"
        y2="135.479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0B5335" />
        <stop offset="1" stopColor="#00170E" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_679:12566"
        x1="266.366"
        y1="119.62"
        x2="255.897"
        y2="131.238"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#44E9A4" />
        <stop offset="1" stopColor="#0A5133" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_679:12566"
        x1="253.444"
        y1="121.176"
        x2="248.52"
        y2="123.053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBF9D" />
        <stop offset="1" stopColor="#D9A97D" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_679:12566"
        x1="407.782"
        y1="73.3089"
        x2="407.282"
        y2="143.001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#44E9A4" />
        <stop offset="1" stopColor="#0A5133" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_679:12566"
        x1="144.416"
        y1="57.274"
        x2="144.903"
        y2="73.1515"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#CFF8E7" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_679:12566"
        x1="551.807"
        y1="73.3824"
        x2="552.183"
        y2="85.8086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#CFF8E7" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_679:12566"
        x1="452.096"
        y1="22.4431"
        x2="452.096"
        y2="40.6401"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A9AEB4" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_679:12566"
        x1="466.305"
        y1="5.97968"
        x2="446.269"
        y2="15.5662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40E5A0" />
        <stop offset="1" stopColor="#44BAC1" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_679:12566"
        x1="452.005"
        y1="15.4573"
        x2="416.188"
        y2="20.4195"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40E5A0" />
        <stop offset="1" stopColor="#44BAC1" />
      </linearGradient>
    </defs>
  </svg>
);

export default Page404;
